import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./TermsConditions.css"; // optional – you can add custom styles if needed

const TermsConditions = () => {
  return (
    <React.Fragment>
      <Header />
      <div className="terms-conditions">
        <Helmet>
          <title>Terms & Conditions - Happy Pay Fintech</title>
          <meta
            name="description"
            content="Terms and conditions for using Happy Pay Fintech services. Please read carefully before using our platform for AEPS, DMT, CMS, PAN card, and bill payment services."
          />
        </Helmet>

        <div className="body-overlay"></div>

        <main>
          {/* ===== Hero / Breadcrumb ===== */}
          <section className="contact-bg pb-130 pt-195">
            <div className="container">
              <div className="row">
                <div className="col-xxl-12">
                  <div className="breadcrumb__content p-relative z-index-1">
                    <h3 className="contact-title">Terms & Conditions</h3>
                    <div className="breadcrumb__list">
                      <span>
                        <a href="/">Home</a>
                      </span>
                      <span className="dvdr"></span>
                      <span>Terms & Conditions</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* ===== Terms Content inside a Card ===== */}
          <div className="container py-5">
            <div className="terms-card p-5 bg-white rounded shadow-sm">
              <h1 className="fw-bold text-center mb-4">Terms & Conditions</h1>
              <p className="text-center text-muted effective-date">
                Last Updated: 18.02.2026
              </p>

              <section className="mb-5">
                <h2>1. Agreement to Terms</h2>
                <p>
                  These Terms & Conditions ("Terms") constitute a legally
                  binding agreement between you ("User", "Retailer", "Agent")
                  and <strong>AYYAAND PAY FINTECH PRIVATE LIMITED</strong>, the
                  owner and operator of the brand{" "}
                  <strong>Happy Pay Fintech</strong>. By accessing or using our
                  website, mobile application, or any of our services including
                  but not limited to AEPS, DMT, CMS, PAN card services, and
                  utility bill payments, you acknowledge that you have read,
                  understood, and agree to be bound by these Terms.
                </p>
                <p>
                  Our registered office is located at: <br />
                  <strong>AYYAAND PAY FINTECH PRIVATE LIMITED</strong>
                  <br />
                  C/o Sri B.channayya, Ter Bazar Main Road Kanakgiri, Near
                  Partana Panchayat, Kanakgiri, Koppal, Karnataka - 583283
                </p>
              </section>

              <section className="mb-5">
                <h2>2. Eligibility</h2>
                <p>
                  Our services are available only to individuals who are at
                  least 18 years of age and to business entities legally capable
                  of entering into binding contracts. By using our platform, you
                  represent and warrant that you meet these eligibility
                  requirements.
                </p>
              </section>

              <section className="mb-5">
                <h2>3. Description of Services</h2>
                <p>
                  Happy Pay Fintech provides a comprehensive digital financial
                  services platform for retailers and agents across India,
                  including but not limited to:
                </p>
                <ul>
                  <li>
                    <strong>AEPS (Aadhaar Enabled Payment System):</strong> Cash
                    withdrawals, balance inquiries, and mini statements using
                    Aadhaar authentication.
                  </li>
                  <li>
                    <strong>DMT (Domestic Money Transfer):</strong> Instant,
                    secure fund transfer to any bank account in India.
                  </li>
                  <li>
                    <strong>CMS (Cash Management Services):</strong> Collection
                    and settlement solutions for businesses.
                  </li>
                  <li>
                    <strong>PAN Card Services:</strong> Instant PAN card
                    issuance and e‑PAN services.
                  </li>
                  <li>
                    <strong>Utility Bill Payments:</strong> Electricity, water,
                    gas, DTH, mobile recharge, and other bill payment services.
                  </li>
                  <li>
                    <strong>Other Services:</strong> Any additional financial or
                    utility services introduced on the platform from time to
                    time.
                  </li>
                </ul>
                <p>
                  All services are subject to availability and may be modified,
                  suspended, or discontinued at our sole discretion without
                  prior notice.
                </p>
              </section>

              <section className="mb-5">
                <h2>4. User Obligations</h2>
                <p>As a user of our platform, you agree to:</p>
                <ul>
                  <li>
                    Provide accurate, complete, and up‑to‑date information
                    during registration and for each transaction.
                  </li>
                  <li>
                    Verify all details (amount, account number, operator, etc.)
                    before confirming any transaction.
                  </li>
                  <li>
                    Maintain the confidentiality of your login credentials and
                    be fully responsible for all activities under your account.
                  </li>
                  <li>
                    Use the platform only for lawful purposes and in compliance
                    with all applicable laws and regulations.
                  </li>
                  <li>
                    Immediately notify us of any unauthorized use of your
                    account or any other security breach.
                  </li>
                </ul>
              </section>

              <section className="mb-5">
                <h2>5. Fees and Payments</h2>
                <p>
                  We may charge convenience fees, service charges, or commission
                  on transactions, which will be clearly displayed before you
                  complete a transaction. All payments are processed in Indian
                  Rupees (INR) through secure payment gateways.
                </p>
                <p>
                  You are responsible for any taxes, duties, or levies
                  applicable to the services you use. AYYAAND PAY FINTECH
                  PRIVATE LIMITED reserves the right to revise its fee structure
                  at any time, with updates effective upon posting on the
                  platform.
                </p>
              </section>

              <section className="mb-5">
                <h2>6. Prohibited Activities</h2>
                <p>
                  You agree not to engage in any of the following prohibited
                  activities:
                </p>
                <ul>
                  <li>
                    Using the platform for any illegal, fraudulent, or
                    unauthorized purpose.
                  </li>
                  <li>
                    Impersonating another person or entity, or misrepresenting
                    your affiliation with any person or entity.
                  </li>
                  <li>
                    Attempting to gain unauthorized access to our systems, user
                    accounts, or data.
                  </li>
                  <li>
                    Interfering with or disrupting the integrity or performance
                    of the platform.
                  </li>
                  <li>
                    Reselling, sub‑licensing, or commercially exploiting our
                    services without express written consent.
                  </li>
                  <li>
                    Using bots, scrapers, or other automated means to access the
                    platform.
                  </li>
                </ul>
              </section>

              <section className="mb-5">
                <h2>7. Intellectual Property</h2>
                <p>
                  All content, logos, trademarks, service marks, software, and
                  technology on the Happy Pay Fintech platform are the exclusive
                  property of AYYAAND PAY FINTECH PRIVATE LIMITED or its
                  licensors. Unauthorized use, reproduction, or distribution is
                  strictly prohibited.
                </p>
              </section>

              <section className="mb-5">
                <h2>8. Refunds & Cancellations</h2>
                <p>
                  Transactions once processed successfully are generally
                  non‑refundable. However, if a transaction fails and the amount
                  is debited from your account, we will initiate a refund as per
                  bank norms. Refunds for failed AEPS, DMT, or bill payment
                  transactions will be processed within 5–7 working days. For
                  any refund‑related queries, please refer to our{" "}
                  <Link to="/refund-policy">Refund Policy</Link>.
                </p>
              </section>

              <section className="mb-5">
                <h2>9. Privacy Policy</h2>
                <p>
                  Your privacy is important to us. Our{" "}
                  <Link to="/privacy-policy">Privacy Policy</Link> explains how
                  we collect, use, disclose, and protect your personal
                  information. By using our services, you consent to the
                  practices described in the Privacy Policy.
                </p>
              </section>

              <section className="mb-5">
                <h2>10. Disclaimers</h2>
                <p>
                  Our platform and services are provided on an "as is" and "as
                  available" basis without warranties of any kind, either
                  express or implied. We do not guarantee that the services will
                  be uninterrupted, error‑free, or secure.
                </p>
                <p>
                  We are not responsible for any delays, failures, or issues
                  caused by third‑party service providers (banks, telecom
                  operators, utility companies, government agencies, etc.).
                </p>
              </section>

              <section className="mb-5">
                <h2>11. Limitation of Liability</h2>
                <p>
                  To the maximum extent permitted by law, AYYAAND PAY FINTECH
                  PRIVATE LIMITED shall not be liable for any indirect,
                  incidental, special, consequential, or punitive damages
                  arising out of or related to your use of our services.
                </p>
                <p>
                  Our total liability, whether in contract, tort, or otherwise,
                  shall not exceed the amount paid by you for the specific
                  transaction that gave rise to the claim.
                </p>
              </section>

              <section className="mb-5">
                <h2>12. Amendments</h2>
                <p>
                  We reserve the right to modify these Terms at any time.
                  Changes will be effective immediately upon posting on this
                  page. Your continued use of the platform after any such
                  changes constitutes your acceptance of the new Terms.
                </p>
              </section>

              <section className="mb-5">
                <h2>13. Governing Law & Jurisdiction</h2>
                <p>
                  These Terms shall be governed by and construed in accordance
                  with the laws of India. Any disputes arising under or in
                  connection with these Terms shall be subject to the exclusive
                  jurisdiction of the courts located in Bengaluru, Karnataka.
                </p>
              </section>

              <section className="mb-5">
                <h2>14. Contact Us</h2>
                <p>
                  If you have any questions or concerns regarding these Terms,
                  you may contact us at:
                </p>
                <address>
                  <strong>AYYAAND PAY FINTECH PRIVATE LIMITED</strong>
                  <br />
                  C/o Sri B.channayya, Ter Bazar Main Road Kanakgiri, Near
                  Partana Panchayat, Kanakgiri, Koppal
                  <br />
                  Karnataka - 583283, India
                  <br />
                  Phone: +91 9741314333
                  <br />
                  Email: happypayfintech@gmail.com
                </address>
              </section>

              <div className="text-center mt-5">
                <p className="mt-3 text-muted">
                  By using our services, you confirm that you agree to these
                  Terms & Conditions.
                </p>
              </div>
            </div>
          </div>
        </main>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default TermsConditions;
